import { DateTime } from './DateTime';
import { Gt } from './Gt';
import { If } from './If';
import { Or } from './Or';
import { Path } from './Path';
import { Uom } from './Uom';
import { PrimaryLineItem } from './PrimaryLineItem';
import { Containers } from './Containers';
import { MatSalesText } from './MatSalesText';
import { ReferenceNumber } from './ReferenceNumber';
import { TruckSeal } from './TruckSeal';
import { CustomSecuenceData } from './CustomSecuenceData';

// Instantiate the handlers
const handlers = [
  new PrimaryLineItem(),
  new Containers(),
  new MatSalesText(),
  new ReferenceNumber(),
  new TruckSeal(),
  new CustomSecuenceData(),
  new Or(),
  new If(),
  new Gt(),
  new Uom(),
  new DateTime(),
  new Path(), // This should remain last.
];

// Chain the handlers
for (let index = 0; index < handlers?.length; index++) {
  const nextHandler = handlers[index + 1];
  handlers[index].setNext(nextHandler);
}

export const processToken = ({ token, context, util }) => {
  return handlers[0].handle({ token, context, util });
};
